import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';
import { RecommendedListsComponent } from './recommended-lists.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.recommendedLists.pageInRouting,
    data: { data: PAGES_AND_PATHS.recommendedLists },
    component: RecommendedListsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./recommended-lists.module').then(m => m.RecommendedListsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RecommendedListsRoutingModule { }
